const INSTALL_DISMISSED_KEY = 'cv_install_dismissed';

let deferredPrompt = null;
let promptListenerAttached = false;

export const isIOSDevice = () => {
    if (typeof navigator === 'undefined') return false;
    const ua = navigator.userAgent;
    return (
        /iPad|iPhone|iPod/.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
};

export const isRunningAsStandalone = () => {
    if (typeof window === 'undefined') return false;
    return (
        window.navigator.standalone === true ||
        window.matchMedia('(display-mode: standalone)').matches
    );
};

export const initInstallPrompt = (onPromptAvailable) => {
    if (typeof window === 'undefined') return;
    if (promptListenerAttached) return;

    promptListenerAttached = true;

    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPrompt = e;
        if (onPromptAvailable) {
            onPromptAvailable();
        }
    });

    window.addEventListener('appinstalled', () => {
        deferredPrompt = null;
    });
};

export const canShowInstallPrompt = () => {
    return deferredPrompt !== null;
};

export const triggerInstallPrompt = async () => {
    if (!deferredPrompt) {
        return null;
    }

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    deferredPrompt = null;
    return outcome;
};

export const getInstallDismissed = () => {
    try {
        return localStorage.getItem(INSTALL_DISMISSED_KEY) === 'true';
    } catch {
        return false;
    }
};

export const setInstallDismissed = () => {
    try {
        localStorage.setItem(INSTALL_DISMISSED_KEY, 'true');
    } catch {
        // localStorage not available
    }
};
